import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Media } from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import defaultLogo from '../../../assets/img/users/default-user-image.png';

class HeaderNotiAdminComponent extends React.Component {

	render() {

		if (this.props.noti_admins && this.props.noti_admins.length ) {
			return (
				 <Scrollbars style={{ width: 250, height: 250 }}>
					{
						this.props.noti_admins.map((noti_admin) => (
							<Link 
								key={noti_admin.id} 
								to={`/admin/noti-admin/detail/${noti_admin.id}`}
							>
						      	<Media className="pb-2">
							        <Media left className="align-self-center pr-3">
							        	<img src={ this.props.website_logo ? this.props.website_logo : defaultLogo } alt="Avatar" className="rounded-circle media-object" style={{ width: 40, height: 40 }} />
							        </Media>
							        <Media body middle className="align-self-center">
							        	{ noti_admin.title }
							        </Media>
							        <Media right className="align-self-center" style={{ width: 60 }} >
							          	<small className="text-muted">{ noti_admin.created_at }</small>
							        </Media>
						      	</Media>
					      	</Link>
					    ))
					}
				</Scrollbars>
			)
	    } else {
	    	return (
	    		<div className="text-center text-danger">
	    			Không có thông báo mới
    			</div>
    		)
	    }
	}

}

const mapStateToProps = (state) => {
  return {
        noti_admins: state.agency.noti_admins,
    	unread_noti_admin: state.agency.unread_noti_admin,
	    website_logo: state.configSystem.config.website_logo,
	}
}

export default connect(mapStateToProps)(HeaderNotiAdminComponent);